export class CityDM {
  constructor({ id = "", country = "", city = "" }) {
    this.id = id;
    this.country = country;
    this.city = city;
  }

  toJson() {
    return {
      id: this.id,
      country: this.country,
      city: this.city,
    };
  }

  static fromJson(json) {
    return new MerchantDM({
      id: json["id"],
      country: json["country"],
      city: json["city"],
    });
  }
}
